import React, { useState, useEffect } from "react";
import { Box, Typography, Button, Link as MUILink } from "@mui/material";
import { Link as RouterLink, useNavigate } from "react-router-dom";

// Resets on a full page load/refresh, but stays true across client-side
// route navigation within the same page load — so the banner only
// reappears on open/refresh, not when navigating back to the Home page.
let hasShownThisPageLoad = false;

const CookieConsentBanner = () => {
  const [visible, setVisible] = useState(() => !hasShownThisPageLoad);
  const navigate = useNavigate();

  useEffect(() => {
    hasShownThisPageLoad = true;
  }, []);

  if (!visible) return null;

  const goToCookiePolicy = () => {
    navigate("/cookie-policy");
  };

  return (
    <Box
      role="dialog"
      aria-label="Cookie consent"
      sx={{
        position: "fixed",
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1400,
        bgcolor: "#fff",
        color: "#000",
        boxShadow: "0 -2px 12px rgba(0,0,0,0.15)",
        px: { xs: 2, md: 5 },
        py: { xs: 2, md: 2.5 },
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        alignItems: { xs: "stretch", md: "center" },
        justifyContent: "space-between",
        gap: { xs: 2, md: 4 },
      }}
    >
      <Typography fontSize={{ xs: 14, md: 15 }} sx={{ flex: 1 }}>
        We use cookies to run this website, understand how it is used, and
        show relevant offers. Read our{" "}
        <MUILink
          component={RouterLink}
          to="/cookie-policy"
          underline="hover"
          sx={{ color: "#e3242b", fontWeight: 600 }}
        >
          Cookie Policy
        </MUILink>
        . You can accept, reject, or customize your choice.
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          gap: 1.5,
          flexShrink: 0,
        }}
      >
        <Button
          onClick={() => setVisible(false)}
          variant="outlined"
          sx={{
            borderColor: "#c9c9c9",
            color: "#000",
            borderRadius: 5,
            px: 3,
            textTransform: "none",
            fontWeight: 600,
            "&:hover": { borderColor: "#000", bgcolor: "transparent" },
          }}
        >
          Reject
        </Button>

        <Button
          onClick={goToCookiePolicy}
          variant="outlined"
          sx={{
            borderColor: "#e3242b",
            color: "#e3242b",
            borderRadius: 5,
            px: 3,
            textTransform: "none",
            fontWeight: 600,
            "&:hover": { borderColor: "#c81d15", bgcolor: "transparent" },
          }}
        >
          Customize
        </Button>

        <Button
          onClick={goToCookiePolicy}
          variant="contained"
          sx={{
            bgcolor: "#e3242b",
            color: "#fff",
            borderRadius: 5,
            px: 3,
            textTransform: "none",
            fontWeight: 600,
            "&:hover": { bgcolor: "#c81d15" },
          }}
        >
          Accept All
        </Button>
      </Box>
    </Box>
  );
};

export default CookieConsentBanner;
